// Graph colour interface
export interface GraphColour {
  id: string
  colour: string
}

// Graph colours definition
export const graphColours: Array<GraphColour> = [
  {
    id: 'National',
    colour: '#5A21BF',
  },
  {
    id: 'NSW',
    colour: '#E95965',
  },
  {
    id: 'VIC',
    colour: '#C313A7',
  },
  {
    id: 'SA',
    colour: '#008763',
  },
  {
    id: 'QLD',
    colour: '#0089BD',
  },
  {
    id: 'WA',
    colour: '#D31E0C',
  },
  {
    id: 'base',
    colour: '#5A21BF',
  },
  {
    id: 'de-seasonalized-smoothed',
    colour: '#E95965',
  },
  {
    id: 'All',
    colour: '#5A21BF',
  },
  {
    id: 'Metro',
    colour: '#E95965',
  },
  {
    id: 'Regional',
    colour: '#0089BD',
  },
]

export const defaultColour = '#5A21BF'
